module.exports = "mutation unlockAdviceRequest($adviceRequestId:String!){unlockAdviceRequest(adviceRequestId:$adviceRequestId)}"